import React from 'react';

import {
  BaseWidget,
  LabelledText
} from 'modules';

import * as dataService from './dataService';



export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);

  return (
    <BaseWidget.FC title="Observed Failure">
      <LabelledText.FC
        title="Q1 Observed Failure"
        text={queryTuple.data.observation?.text ?? 'N/A'} />

      <LabelledText.FC
        title="Observation Date"
        text={queryTuple.data.observation?.createdTimestamp?.toFormat('MM/dd/yy') ?? 'N/A'} />

      <LabelledText.FC
        title="Technician"
        text={queryTuple.data.observation?.technicianFullName || 'N/A'} />
    </BaseWidget.FC>
  );
};
